import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast, ToastContainer } from "../../../utils/toast";

const BookingInquiryModal = ({ cardId, bookingType }) => {

    // console.log('cardId', cardId);
    // console.log('bookingType', bookingType);
    const [pickupSuggestions, setPickupSuggestions] = React.useState([]);
    const [dropSuggestions, setDropSuggestions] = React.useState([]);
    const initialValues = {
        card_id: cardId || "",
        booking_type: bookingType || "",
        name: "",
        email: "",
        phone: "",
        pick_up_location: "",
        pick_up_lat: "",
        pick_up_lng: "",
        drop_up_location: "",
        drop_up_lat: "",
        drop_up_lng: "",
        pick_up_date: "",
        pick_up_time: "",
        vehicle_preference: "",
        details: "",
    };

    const validationSchema = Yup.object({
        name: Yup.string().required("Full Name is required"),
        email: Yup.string().email("Invalid email").required("Email is required"),
        phone: Yup.string().matches(/^\d{10}$/, "Phone must be 10 digits").required(),
        pick_up_location: Yup.string().required("Pick-up Location is required"),
        drop_up_location: Yup.string().required("Drop Location is required"),
        pick_up_date: Yup.string().required("Pick-up Date is required"),
        pick_up_time: Yup.string().required("Pick-up Time is required"),
        vehicle_preference: Yup.string().required("Vehicle Preference is required"),
    });
    const autocompleteService = new window.google.maps.places.AutocompleteService();
    const placesService = new window.google.maps.places.PlacesService(
        document.createElement("div")
    );
    const fetchPlaces = (text, type) => {
        if (!text || text.length < 3) {
            type === "pickup" ? setPickupSuggestions([]) : setDropSuggestions([]);
            return;
        }

        autocompleteService.getPlacePredictions(
            { input: text, componentRestrictions: { country: "in" } },
            (predictions, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                    type === "pickup"
                        ? setPickupSuggestions(predictions)
                        : setDropSuggestions(predictions);
                }
            }
        );
    };
    const handleSelectPlace = (item, type, setFieldValue) => {
        placesService.getDetails(
            { placeId: item.place_id },
            (place, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                    const lat = place.geometry.location.lat();
                    const lng = place.geometry.location.lng();

                    if (type === "pickup") {
                        setFieldValue("pick_up_location", place.formatted_address);
                        setFieldValue("pick_up_lat", lat);
                        setFieldValue("pick_up_lng", lng);
                        setPickupSuggestions([]);
                    } else {
                        setFieldValue("drop_up_location", place.formatted_address);
                        setFieldValue("drop_up_lat", lat);
                        setFieldValue("drop_up_lng", lng);
                        setDropSuggestions([]);
                    }
                }
            }
        );
    };
    const handleSubmit = async (values, { resetForm, setSubmitting }) => {
        // console.log("FINAL PAYLOAD SENT ✅", values);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_APP_DOMAIN}/api/customer/booking-inquiry/store`,
                values
            );

            if (response.data.status === true || response.data.status === "success") {
                toast.success(response.data.message || "Booking inquiry submitted successfully!");
                resetForm();
                document.querySelector("#booking-modal .btn-close")?.click();
            } else {
                toast.error(response.data.message || "Something went wrong");
            }
        } catch (error) {
            toast.error("Server error. Please try again later.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <div className="modal booking_modal fade" id="booking-modal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog booking_modalDialog">
                    <div className="modal-content booking_modalContant">
                        <div className="modal-header">
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        <div className="modal-body booking_modalBody">
                            <div className="business_right bookInquery_right">
                                <h2 className="text-center">Booking Inquiry</h2>

                                <Formik
                                    enableReinitialize
                                    initialValues={initialValues}
                                    validationSchema={validationSchema}
                                    onSubmit={handleSubmit}
                                >
                                    {({ setFieldValue, isSubmitting }) => (
                                        <Form className="bookingInquiryForm">
                                            {/* Hidden fields */}
                                            <Field type="hidden" name="card_id" value={cardId} />
                                            <Field type="hidden" name="booking_type" value={bookingType} />


                                            <div className="row g-2">
                                                <div className="col-md-6">
                                                    <label className="form-label">Full Name*</label>
                                                    <Field name="name" className="form-control" placeholder="Enter your full name" />
                                                    <ErrorMessage name="name" component="small" className="text-danger" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label className="form-label">Email*</label>
                                                    <Field name="email" type="email" className="form-control" placeholder="Enter your email" />
                                                    <ErrorMessage name="email" component="small" className="text-danger" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label className="form-label">Phone*</label>
                                                    <Field name="phone" className="form-control" placeholder="Enter your phone number" />
                                                    <ErrorMessage name="phone" component="small" className="text-danger" />
                                                </div>

                                                <div className="col-md-6 position-relative">
                                                    <label>Pick-up Location*</label>
                                                    <Field
                                                        name="pick_up_location"
                                                        className="form-control"
                                                        placeholder="Enter pick-up location"
                                                        onChange={(e) => {
                                                            setFieldValue("pick_up_location", e.target.value);
                                                            fetchPlaces(e.target.value, "pickup");
                                                        }}
                                                    />

                                                    {pickupSuggestions.length > 0 && (
                                                        <ul className="list-group position-absolute w-100 z-3">
                                                            {pickupSuggestions.map((item) => (
                                                                <li
                                                                    key={item.place_id}
                                                                    className="list-group-item list-group-item-action"
                                                                    onClick={() =>
                                                                        handleSelectPlace(item, "pickup", setFieldValue)
                                                                    }
                                                                >
                                                                    {item.description}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}

                                                    <ErrorMessage name="pick_up_location" component="div" className="text-danger small" />
                                                </div>

                                                {/* <div className="col-md-6">
                                                                                <label>Drop Location*</label>
                                                                                <Field type="text" name="drop_up_location" className="form-control" placeholder="Enter drop address" />
                                                                                <ErrorMessage name="drop_up_location" component="div" className="text-danger small" />
                                                                            </div> */}
                                                <div className="col-md-6 position-relative">
                                                    <label>Drop Location*</label>
                                                    <Field
                                                        name="drop_up_location"
                                                        className="form-control"
                                                        placeholder="Enter drop location"
                                                        onChange={(e) => {
                                                            setFieldValue("drop_up_location", e.target.value);
                                                            fetchPlaces(e.target.value, "drop");
                                                        }}
                                                    />

                                                    {dropSuggestions.length > 0 && (
                                                        <ul className="list-group position-absolute w-100 z-3">
                                                            {dropSuggestions.map((item) => (
                                                                <li
                                                                    key={item.place_id}
                                                                    className="list-group-item list-group-item-action"
                                                                    onClick={() =>
                                                                        handleSelectPlace(item, "drop", setFieldValue)
                                                                    }
                                                                >
                                                                    {item.description}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}

                                                    <ErrorMessage name="drop_up_location" component="div" className="text-danger small" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label className="form-label">Pick-up Date*</label>
                                                    <Field type="date" name="pick_up_date" className="form-control" />
                                                    <ErrorMessage name="pick_up_date" component="small" className="text-danger" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label className="form-label">Pick-up Time*</label>
                                                    <Field type="time" name="pick_up_time" className="form-control" />
                                                    <ErrorMessage name="pick_up_time" component="small" className="text-danger" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label className="form-label">Vehicle Preference*</label>
                                                    <Field name="vehicle_preference" className="form-control" placeholder="e.g., Sedan, SUV" />
                                                    <ErrorMessage name="vehicle_preference" component="small" className="text-danger" />
                                                </div>

                                                <div className="col-12">
                                                    <label className="form-label">Additional Details</label>
                                                    <Field as="textarea" name="details" rows="3" className="form-control" placeholder="Enter any specific requirements or notes" />
                                                </div>

                                                <div className="col-12 text-center">
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary px-5 py-2"
                                                        disabled={isSubmitting}
                                                    >
                                                        {isSubmitting ? (
                                                            <>
                                                                <span
                                                                    className="spinner-border spinner-border-sm me-2"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                ></span>
                                                                Submitting...
                                                            </>
                                                        ) : (
                                                            "Submit"
                                                        )}
                                                    </button>
                                                </div>

                                            </div>
                                        </Form>
                                    )}
                                </Formik>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
};

export default BookingInquiryModal;
